import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.regexp.constructor.js";
import "core-js/modules/es6.regexp.replace.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.starts-with.js";
import { SEARCH_TEXT } from '../constants';

var removeBannerTextFromContent = function removeBannerTextFromContent(bullet, textToRemove) {
  var regex = new RegExp("^".concat(textToRemove, "[!:\\- ]+"), 'gi');
  return bullet.replace(regex, '');
};

export var findOurTakeHighlightContent = function findOurTakeHighlightContent(marketingBullets) {
  if (!_isEmpty(marketingBullets)) {
    var matchingBullets = marketingBullets.filter(function (bullet) {
      var bulletLower = bullet.toLowerCase();
      return bulletLower.startsWith(SEARCH_TEXT.NEW) || bulletLower.startsWith(SEARCH_TEXT.LIMITED) || bulletLower.startsWith(SEARCH_TEXT.NERDWALLET);
    }).map(function (bullet) {
      var bulletLower = bullet.toLowerCase();

      if (bulletLower.startsWith(SEARCH_TEXT.NEW)) {
        return {
          type: 'NEW',
          content: removeBannerTextFromContent(bullet, SEARCH_TEXT.NEW)
        };
      }

      if (bulletLower.startsWith(SEARCH_TEXT.LIMITED)) {
        return {
          type: 'LIMITED',
          content: removeBannerTextFromContent(bullet, SEARCH_TEXT.LIMITED)
        };
      }

      return {
        type: 'NERDWALLET',
        content: removeBannerTextFromContent(bullet, SEARCH_TEXT.NERDWALLET)
      };
    });
    return matchingBullets[0] || null;
  }

  return null;
};